import { Component } from '@angular/core';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss']
})
export class InstructionsComponent {

  instructions : { no: string, text: string}[] = [
    {
      no:'01',
      text:'Each question is worth 10 points.'
    },
    {
      no:'02',
      text:'Complete the quiz within the given time limit.'
    },
    {
      no:'03',
      text:'Each quiz can only be attempted once.'
    },
    {
      no:'04',
      text:'In case of a tie in points, the team that finishes first will be declared the winner.'
    },
    {
      no:'05',
      text:'No cheating or collaboration with other students during the quiz.'
    }
  ]

  constructor() { }

}